"use client";
import {
  Link_default
} from "./chunk-ZRVIWEMV.mjs";
import {
  Loading_default
} from "./chunk-OHBYOOB4.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";
import {
  button,
  link
} from "./chunk-FCJWRTKO.mjs";
import {
  useCMSLink
} from "./chunk-XDMW23CP.mjs";

// src/components/atoms/Button/Button.tsx
import { forwardRef } from "react";
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
function ButtonContent({
  isLoading,
  iconName,
  iconPosition,
  label,
  children
}) {
  return /* @__PURE__ */ jsxs(Loading_default, { isLoading: Boolean(isLoading), children: [
    iconName && iconPosition === "left" && /* @__PURE__ */ jsx(Icon_default, { name: iconName, className: "fill-current w-[24px] h-[24px]" }),
    label && /* @__PURE__ */ jsx(
      "span",
      {
        dangerouslySetInnerHTML: {
          __html: label || ""
        }
      }
    ),
    children,
    iconName && iconPosition === "right" && /* @__PURE__ */ jsx(Icon_default, { name: iconName, className: "fill-current w-[24px] h-[24px]" })
  ] });
}
var Button = forwardRef(function Button2({
  color,
  type = "button",
  className = "",
  linkPathname,
  linkQuery,
  linkHash,
  linkHref,
  linkTarget,
  isLoading,
  disabled,
  onClick,
  fullWidth,
  dataTestId,
  uiStyleVariant = "button",
  ...rest
}) {
  const { getHrefFromCMSParams } = useCMSLink();
  return linkPathname || linkHash || linkQuery || linkHref ? /* @__PURE__ */ jsx(
    Link_default,
    {
      href: getHrefFromCMSParams({
        hash: linkHash,
        pathname: linkPathname,
        query: linkQuery,
        href: linkHref
      }),
      target: linkTarget,
      onClick,
      "data-testid": dataTestId,
      className: classNames({
        [button({ color, className })]: uiStyleVariant === "button",
        [link({ color, className })]: uiStyleVariant === "link"
      }),
      children: /* @__PURE__ */ jsx(ButtonContent, { ...rest })
    }
  ) : /* @__PURE__ */ jsx(
    "button",
    {
      type,
      disabled: disabled || isLoading,
      className: button({ color, fullWidth, className }),
      onClick,
      "data-testid": dataTestId,
      children: /* @__PURE__ */ jsx(ButtonContent, { ...rest })
    }
  );
});
var Button_default = Button;

export {
  Button_default
};
